module.exports = __webpack_public_path__ + "img/claimproses.5131b95e.svg";